export const COOKIE_CONSENT_KEY = 'feed_cookie_consent_v1';
export const COOKIE_CONSENT_EVENT = 'feed:cookie-consent';

export function readCookieConsent() {
  try {
    const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function saveCookieConsent(value) {
  if (value !== 'accepted' && value !== 'rejected') return;
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch {
    // A escolha ainda vale para a sessão atual quando o storage está bloqueado.
  }
  window.dispatchEvent(new window.CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
}
